import type { ReactNode } from "react";

export function QuestionHeader({
  title,
  subtitle,
  required,
  htmlFor,
}: {
  title: string;
  subtitle?: ReactNode;
  required?: boolean;
  htmlFor?: string;
}) {
  return (
    <div className="space-y-2">
      <label
        htmlFor={htmlFor}
        className="block text-xl font-semibold leading-snug tracking-tight"
      >
        {title}
        {required ? <span className="text-fg-muted"> *</span> : null}
      </label>
      {subtitle ? (
        <p className="text-sm text-fg-muted leading-relaxed">{subtitle}</p>
      ) : null}
    </div>
  );
}
